(function () {
  const overlay = document.getElementById('mandira-cart-overlay');
  const openBtns = document.querySelectorAll('[data-cart-drawer-open]');
  if (!overlay || !openBtns.length) return;

  const closeBtns = overlay.querySelectorAll('[data-cart-drawer-close]');
  const moneyFormat =
    window.MandiraCart?.moneyFormat ||
    window.Shopify?.money_format ||
    'Rs. {{amount}}';

  function isOpen() {
    return overlay.classList.contains('expanded');
  }

  function openCart(event) {
    if (event) event.preventDefault();
    const header = document.querySelector('.site-header');
    if (header) {
      header.classList.add('site-header--solid');
      header.classList.remove('site-header--transparent', 'site-header--hidden');
    }
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('expanded'));
    document.documentElement.classList.add('cart-drawer-open');
  }

  function closeCart(event) {
    if (event) event.preventDefault();
    overlay.classList.remove('expanded');
    document.documentElement.classList.remove('cart-drawer-open');
    window.setTimeout(() => {
      if (!isOpen()) overlay.hidden = true;
      /* Restore homepage transparent header when at top */
      if (typeof window.MandiraHeader?.apply === 'function') {
        window.MandiraHeader.apply();
      }
    }, 280);
  }

  function toggleCart(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (isOpen()) closeCart();
    else openCart();
  }

  openBtns.forEach((btn) => btn.addEventListener('click', toggleCart));
  closeBtns.forEach((btn) => btn.addEventListener('click', closeCart));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) closeCart();
  });

  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('cart') === 'open') {
      openCart();
      params.delete('cart');
      const next = params.toString();
      const url =
        window.location.pathname + (next ? `?${next}` : '') + window.location.hash;
      window.history.replaceState({}, '', url);
    }
  } catch (_) {
    /* ignore */
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    if (window.Shopify?.formatMoney) {
      try {
        return window.Shopify.formatMoney(cents, moneyFormat);
      } catch (_) {
        /* fall through */
      }
    }
    const formatted = amount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, formatted).replace(
      /\{\{\s*amount_no_decimals\s*\}\}/g,
      Math.round(amount).toLocaleString('en-IN'),
    );
  }

  function sizeLabel(item) {
    const options = item.options_with_values || [];
    for (let i = 0; i < options.length; i += 1) {
      const name = String(options[i].name || '').toLowerCase();
      if (name.includes('size')) return options[i].value;
    }
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }
    return '';
  }

  function formatItemCountLabel(count) {
    const n = Number(count) || 0;
    const padded = String(n).padStart(2, '0');
    return padded + ' ' + (n === 1 ? 'Item' : 'Items');
  }

  function updateCartBadge(count) {
    const n = Number(count) || 0;
    document.querySelectorAll('[data-cart-drawer-open]').forEach((link) => {
      link.setAttribute('aria-label', `Cart with ${n} items`);
      let badge = link.querySelector('.cart-count-badge');
      if (n > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count-badge';
          link.appendChild(badge);
        }
        badge.textContent = String(n);
      } else if (badge) {
        badge.remove();
      }
    });
    const countEl = overlay.querySelector('[data-cart-item-count]');
    if (countEl) countEl.textContent = formatItemCountLabel(n);
  }

  function emptyCartHtml() {
    const shopUrl =
      window.MandiraCart?.continueUrl || '/collections/all-clothing';
    return (
      '<div class="cart-empty">' +
      '<h3>Your cart is empty</h3>' +
      "<p>Looks like you haven't added anything yet.<br>Let's get you started!</p>" +
      `<a href="${escapeHtml(shopUrl)}" class="btn-shop" data-cart-drawer-close>Continue Shopping</a>` +
      '</div>'
    );
  }

  function lineItemHtml(item) {
    const title = escapeHtml(item.product_title || item.title || '');
    const size = sizeLabel(item);
    const sizeHtml = size
      ? `<p class="line-variant">Size- ${escapeHtml(size)}</p>`
      : '';
    const image = item.image || item.featured_image?.url || '';
    const imgHtml = image
      ? `<img src="${escapeHtml(image)}" alt="${title}" width="86" height="118" loading="lazy">`
      : '';
    const url = escapeHtml(item.url || '#');
    const key = escapeHtml(item.key);
    const qty = Number(item.quantity) || 0;
    const price = formatMoney(item.final_line_price);
    const decDisabled = qty <= 1 ? ' disabled' : '';
    const productId = item.product_id || '';
    const variantId = item.variant_id || item.id || '';
    const handle = escapeHtml(item.handle || '');

    return (
      `<li class="cart-line-item" data-cart-line-key="${key}">` +
      `<a href="${url}" class="line-image" data-cart-drawer-close>${imgHtml}</a>` +
      '<div class="line-details">' +
      '<div class="line-top">' +
      '<div class="line-info">' +
      `<a href="${url}" class="line-title" data-cart-drawer-close><h4>${title}</h4></a>` +
      sizeHtml +
      '</div>' +
      `<p class="line-price">${escapeHtml(price)}</p>` +
      '</div>' +
      '<div class="cart-line-quantity">' +
      `<form action="/cart/change" method="post" data-cart-ajax-form data-cart-action="decrease">` +
      `<input type="hidden" name="id" value="${key}">` +
      `<input type="hidden" name="quantity" value="${Math.max(0, qty - 1)}">` +
      `<button type="submit" class="cart-line-qty-btn" aria-label="Decrease quantity"${decDisabled}>−</button>` +
      '</form>' +
      `<span class="cart-line-qty-value">${qty}</span>` +
      `<form action="/cart/change" method="post" data-cart-ajax-form data-cart-action="increase">` +
      `<input type="hidden" name="id" value="${key}">` +
      `<input type="hidden" name="quantity" value="${qty + 1}">` +
      '<button type="submit" class="cart-line-qty-btn" aria-label="Increase quantity">+</button>' +
      '</form>' +
      '</div>' +
      '<div class="line-links">' +
      `<button type="button" class="line-wishlist" data-wishlist-btn data-product-id="${escapeHtml(productId)}" data-product-handle="${handle}" data-variant-id="${escapeHtml(variantId)}" data-product-title="${title}" data-product-url="${url}" data-wishlist-price="${escapeHtml(price)}" data-product-image="${escapeHtml(image)}">Add to Wishlist</button>` +
      `<form action="/cart/change" method="post" class="cart-line-remove-form" data-cart-ajax-form data-cart-action="remove">` +
      `<input type="hidden" name="id" value="${key}">` +
      '<input type="hidden" name="quantity" value="0">' +
      '<button type="submit" class="line-remove">Remove from Cart</button>' +
      '</form>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function renderCart(cart) {
    const main = overlay.querySelector('.cart-main');
    if (!main) return;

    updateCartBadge(cart.item_count || 0);

    if (!cart.item_count || !cart.items?.length) {
      main.innerHTML = emptyCartHtml();
      bindDrawerChrome();
      return;
    }

    const lines = cart.items.map(lineItemHtml).join('');
    main.innerHTML =
      '<div class="cart-details cart-details--flex">' +
      '<p id="cart-drawer-lines" class="sr-only">Line items</p>' +
      `<div><ul aria-labelledby="cart-drawer-lines">${lines}</ul></div>` +
      '<div class="cart-summary cart-summary-aside cart-summary-aside-only">' +
      '<div class="checkout-actions">' +
      '<form action="/cart" method="post">' +
      '<button type="submit" name="checkout" class="btn-checkout">Checkout</button>' +
      '</form>' +
      '</div></div></div>';

    bindDrawerChrome();
  }

  function bindDrawerChrome() {
    overlay.querySelectorAll('[data-cart-drawer-close]').forEach((btn) => {
      btn.addEventListener('click', closeCart);
    });
  }

  async function changeCart(lineKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: Number(quantity),
      }),
      credentials: 'same-origin',
    });

    if (!response.ok) {
      let message = 'Could not update cart';
      try {
        const err = await response.json();
        if (err?.description) message = err.description;
        else if (err?.message) message = err.message;
      } catch (_) {
        /* ignore */
      }
      throw new Error(message);
    }

    const data = await response.json();
    /* change.js returns full cart; if not, refresh from cart.js */
    if (data && Array.isArray(data.items)) return data;
    const cartRes = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!cartRes.ok) throw new Error('Could not load cart');
    return cartRes.json();
  }

  async function onCartFormSubmit(event) {
    const form = event.target.closest('[data-cart-ajax-form]');
    if (!form || !overlay.contains(form)) return;

    event.preventDefault();
    event.stopPropagation();

    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const lineKey = idInput?.value;
    const quantity = qtyInput ? Number(qtyInput.value) : 0;
    if (!lineKey) return;

    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    form.setAttribute('aria-busy', 'true');

    try {
      const cart = await changeCart(lineKey, quantity);
      renderCart(cart);
      if (!isOpen()) openCart();
    } catch (error) {
      console.error('[Mandira cart]', error);
      window.alert(error?.message || 'Could not update cart. Please try again.');
      if (submitBtn && quantity !== 0) submitBtn.disabled = false;
    } finally {
      form.removeAttribute('aria-busy');
    }
  }

  overlay.addEventListener('submit', onCartFormSubmit);

  window.MandiraCartDrawer = {
    open: openCart,
    close: closeCart,
    toggle: toggleCart,
    render: renderCart,
    refresh: async function refreshCart() {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error('Could not load cart');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    },
  };
})();
